import React from 'react';
import StatCard from '../atoms/StatCard';
import './StatsGrid.css';

interface DashboardStats {
  totalOrders: number;
  processingOrders: number;
  completedOrders: number;
  totalRevenue: number;
}

interface StatsGridProps {
  stats: DashboardStats;
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  // Calculate completion rate
  const completionRate = stats.totalOrders > 0
    ? Math.round((stats.completedOrders / stats.totalOrders) * 100)
    : 0;

  const statItems = [
    {
      title: 'Total Orders',
      value: stats.totalOrders,
      change: `${stats.totalOrders} orders placed`,
      changeType: 'neutral' as const,
      icon: 'cart' as const,
      iconType: 'orders' as const
    },
    {
      title: 'Processing Orders',
      value: stats.processingOrders,
      change: stats.processingOrders > 0 ? 'Currently being processed' : 'No processing orders',
      changeType: stats.processingOrders > 0 ? 'positive' as const : 'neutral' as const,
      icon: 'clock' as const,
      iconType: 'pending' as const
    },
    {
      title: 'Completed Revenue',
      value: `€${stats.totalRevenue.toLocaleString()}`,
      change: stats.completedOrders > 0
        ? `€${Math.round(stats.totalRevenue / stats.completedOrders).toLocaleString()} avg per completed order`
        : 'No completed orders yet',
      changeType: 'positive' as const,
      icon: 'dollar' as const,
      iconType: 'revenue' as const
    },
    {
      title: 'Completed Orders',
      value: stats.completedOrders,
      change: completionRate > 0 ? `${completionRate}% completed in range` : 'No completed orders in range',
      changeType: completionRate > 0 ? 'positive' as const : 'neutral' as const,
      icon: 'cart' as const,
      iconType: 'orders' as const
    }
  ];

  return (
    <div className="stats-grid">
      {statItems.map((item, index) => (
        <StatCard
          key={index}
          title={item.title}
          value={item.value}
          change={item.change}
          changeType={item.changeType}
          icon={item.icon}
          iconType={item.iconType}
        />
      ))}
    </div>
  );
};

export default StatsGrid;
